import { AxiosResponse } from 'axios';
import { IContactUsPayload } from '../redux/general/generalSlice';
import { backendApiInstance } from './backendApiInstance';

export async function sendContactUsMessage(data: IContactUsPayload): Promise<AxiosResponse> {
  return backendApiInstance.post('/contact-us', data);
}

export async function validatePaymentMethodSuccess(email: string): Promise<AxiosResponse> {
  return backendApiInstance.post('/users/validate-payment-method-success', { email });
}
